import Vue from 'vue'
import Router from 'vue-router'
import Head from '@/components/headTop'
import Fotter from '@/components/fotter'
import Login from '@/components/login'
import Register from '@/components/register'
import PayOrder from '@/components/payOrder'
import Agreement from '@/components/agreement'
import SkiResortDetail from '@/components/skiResortDetail'
import AboutUs from '@/components/aboutUs'
import Index from '@/page/index'
import CommodityDetail from '@/page/commodityDetail'
import Business from '@/page/business'
import MyOrder from '@/page/myOrder'
import OrderPay from '@/page/orderPay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/fotter',
      name: 'fotter',
      component: Fotter
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/head',
      name: 'head',
      component: Head
    },
    {
      path: '/commodityDetail',
      name: 'commodityDetail',
      component: CommodityDetail
    },
    {
      path: '/business',
      name: 'business',
      component: Business
    },
    {
      path: '/payOrder',
      name: 'payOrder',
      component: PayOrder
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement
    },
    {
      path: '/skiResortDetail',
      name: 'skiResortDetail',
      component: SkiResortDetail
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: AboutUs
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: MyOrder
    },
    {
      path: '/orderPay',
      name: 'orderPay',
      component: OrderPay
    }
  ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js